import { render, staticRenderFns } from "./BannerSetting.vue?vue&type=template&id=4b59d518&scoped=true"
import script from "./BannerSetting.vue?vue&type=script&lang=js"
export * from "./BannerSetting.vue?vue&type=script&lang=js"
import style0 from "./BannerSetting.vue?vue&type=style&index=0&id=4b59d518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59d518",
  null
  
)

export default component.exports